<template>
  <div v-bind="$attrs" :class="['ews-input', outerClass, $attrs?.class || ''].join(' ')">
    <label v-if="label" :class="labelClass">{{ label }}</label>
    <div :class="['ews-input-wrapper', wrapperClass].join(' ')">
      <div :class="['ews-input-inner', innerClass].join(' ')">
        <slot name="antDesignSlot" :antDesignProps="antDesignProps">
          <form-antd-textarea
            v-bind="antDesignProps || {}"
            :modelValue="modelValue"
            :placeholder="placeholder"
            :class="['form-textarea block', inputClass].join(' ')"
            @update:value="(newValue) => $emit('update:modelValue', newValue)"
          />
        </slot>
      </div>
    </div>
    <div v-if="help" :class="helpClass">{{ help }}</div>
  </div>
</template>

<script>
import FormAntdTextarea from './AntDesign/FormAntdTextarea.vue'

export default {
  name: 'FormTextarea',
  inheritAttrs: false,
  components: {
    FormAntdTextarea
  },
  props: {
    /**
     * Label text.
     */
    label: {
      type: String,
      default: ''
    },
    /**
     * Placeholder text.
     */
    placeholder: {
      type: String,
      default: ''
    },
    /**
     * Value bound via v-model.
     */
    modelValue: {
      type: [String, Number, Object],
      default: ''
    },
    /**
     * Help text displayed after the element.
     */
    help: String,
    /**
     * Additional classes for the wrapper.
     */
    wrapperClass: {
      type: String,
      default: ''
    },
    /**
     * Additional classes for the outer.
     */
    outerClass: {
      type: String,
      default: ''
    },
    /**
     * Additional classes for the inner.
     */
    innerClass: {
      type: String,
      default: 'w-full'
    },
    /**
     * Additional classes for the input.
     */
    inputClass: {
      type: String,
      default: 'w-full'
    },
    /**
     * Additional classes for the label.
     */
    labelClass: {
      type: String,
      default: 'text-gray-700 font-semibold text-base ml-2 mb-1 inline-block'
    },
    /**
     * Additional classes for help text.
     */
    helpClass: {
      type: String,
      default: 'text-cool-gray-500 font-light text-sm ml-1'
    },
    /**
     * Additional classes for error text.
     */
    errorClass: {
      type: String,
      default: 'text-red-700 font-light text-sm ml-1'
    },
    /**
     * Ant Design Props.
     */
    antDesignProps: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  emits: ['update:modelValue']
}
</script>

<style></style>
